import * as KendoChart from '@progress/kendo-react-charts'
import * as KendoGrid from '@progress/kendo-react-grid'
import moment from 'moment'
import * as React from 'react'
import {connect} from 'react-redux'
import {Col, Row} from 'reactstrap'
import * as App from '../../app'
import * as Colors from '../../colors'
import {FlashMessage} from '../../components/flash-message'
import {AnchorLink} from '../../components/link'
import {Loading} from '../../components/loading'
import { WordCloud } from '../../components/word-cloud'
import './styles.css'
import * as Types from './types'

type Props = Types.WrappedState & App.WrappedState
export const Home: React.SFC<Props> = ({app, home, members}) => <div className="home">
  <FlashMessage/>
  {home.view.emailActions.isLoading || home.view.tags.isLoading ? <Loading center size={Loading.Sizes.LARGE}/> :
    <div>
      <h2>Monthly Snapshot</h2>
      <Row className="row-1">
        <Col sm="12" md="6">
          <KendoChart.Chart transitions={false} pannable={false} zoomable={false}>
            <KendoChart.ChartLegend position="bottom" orientation="horizontal"/>
            <KendoChart.ChartCategoryAxis>
              <KendoChart.ChartCategoryAxisItem
                categories={home.engagementReport.chart.map(({timestamp}) =>
                  moment(timestamp).utc().format('ddd, MMM Do'))} />
            </KendoChart.ChartCategoryAxis>
            <KendoChart.ChartTooltip
              render={({points}: KendoChart.SharedTooltipContext) => <div>
                <h5>
                  {moment(points[0].dataItem.timestamp).utc().format('ddd, MMM Do, YYYY')}
                </h5>
              {points.map((point) =>
                <div key={point.series.name + point.value} style={{color: point.series.color}}>
                  {point.series.name}: {point.value}%
                </div>)}
              </div>}
              shared={true} />
              <KendoChart.ChartSeries>
                <KendoChart.ChartSeriesItem
                  type="line"
                  color={Colors.cyan300}
                  field="uniqueClickRate"
                  name="Unique Click Rate"
                  data={home.engagementReport.chart}>
                    <KendoChart.ChartSeriesLabels format="{0:N2}%" />
                </KendoChart.ChartSeriesItem>
                <KendoChart.ChartSeriesItem
                  type="line"
                  color={Colors.cyan500}
                  field="uniqueOpenRate"
                  name="Unique Open Rate"
                  data={home.engagementReport.chart}>
                    <KendoChart.ChartSeriesLabels format="{0:N2}%" />
                </KendoChart.ChartSeriesItem>
              </KendoChart.ChartSeries>
          </KendoChart.Chart>
          <AnchorLink className="see-more" href="/reports/opens-clicks">See More</AnchorLink>
        </Col>
        <Col sm="12" md="6">
          <WordCloud data={home.tagCloud} />
          <AnchorLink className="see-more" href="/reports/top-topics">See More</AnchorLink>
        </Col>
      </Row>
      <Row className="row-2">
        <Col sm="12" md="6">
          <KendoGrid.Grid data={home.engagementReport.topSources}>
            <KendoGrid.GridColumn field="source" title="Top Sources" />
            <KendoGrid.GridColumn field="count" title="Click Count" width="200px"/>
          </KendoGrid.Grid>
          <AnchorLink className="see-more" href="/reports/sources">See More</AnchorLink>
        </Col>
        <Col sm="12" md="6">
              <Row>
                <h2>Weekly Averages</h2>
              </Row>

              <Row>
                <Col sm="12" md="6">
                  <div className="big-numbers unique">
                    <div className="big-number">
                      <h4>Unique Open Rate</h4>
                      <p>{home.engagementReport.bigNumbers.uniqueOpenRate} %</p>
                    </div>
                    <div className="big-number">
                      <h4>Unique Click Rate</h4>
                      <p>{home.engagementReport.bigNumbers.uniqueClickRate} %</p>
                    </div>
                  </div>
                </Col>
                <Col sm="12" md="6">
                  <div className="big-numbers unique">
                    <div className="big-number">
                      <h4>Subscribers</h4>
                      <p>{home.engagementReport.totalActiveMembers}</p>
                    </div>
                    <div className="big-number">
                      <h4>Bounce Rate</h4>
                      <p>{home.engagementReport.bigNumbers.bounceRate} %</p>
                    </div>
                  </div>
                </Col>
              </Row>
          <AnchorLink className="see-more" href="/reports/opens-clicks">See More</AnchorLink>
        </Col>
      </Row>
    </div>}
</div>

export const HomeConnected = connect(
  ({app, home, members}: Props) => ({app, home, members}),
)(Home)



// WEBPACK FOOTER //
// ./src/pages/home/component.tsx